import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Box,
  Typography,
  CircularProgress,
  Divider,
} from '@mui/material';
import { useAppSelector } from '../../store/hooks';

interface ViewModalProps {
  open: boolean;
  onClose: () => void;
}

const ViewModal: React.FC<ViewModalProps> = ({ open, onClose }) => {
  const { selectedSection, loading } = useAppSelector((state) => state.chatbotSections);

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Detalle de Sección de Chatbot</DialogTitle>
      <DialogContent>
        {loading ? (
          <Box display="flex" justifyContent="center" alignItems="center" minHeight="200px">
            <CircularProgress />
          </Box>
        ) : selectedSection ? (
          <Box sx={{ mt: 2 }}>
            <Box sx={{ mb: 2 }}>
              <Typography variant="subtitle2" color="text.secondary">Código</Typography>
              <Typography variant="body1" sx={{ mb: 2 }}>{selectedSection.code}</Typography>
              <Divider />
            </Box>

            <Box sx={{ mb: 2 }}>
              <Typography variant="subtitle2" color="text.secondary">Nombre</Typography>
              <Typography variant="body1" sx={{ mb: 2 }}>{selectedSection.name}</Typography>
              <Divider />
            </Box>

            <Box sx={{ mb: 2 }}>
              <Typography variant="subtitle2" color="text.secondary">Descripción</Typography>
              <Typography variant="body1" sx={{ mb: 2 }}>{selectedSection.description || '(vacío)'}</Typography>
              <Divider />
            </Box>

            <Box sx={{ mb: 2 }}>
              <Typography variant="subtitle2" color="text.secondary">Fecha de Creación</Typography>
              <Typography variant="body1" sx={{ mb: 2 }}>{selectedSection.createdAt}</Typography>
              <Divider />
            </Box>

            <Box sx={{ mb: 2 }}>
              <Typography variant="subtitle2" color="text.secondary">Creado Por</Typography>
              <Typography variant="body1" sx={{ mb: 2 }}>{selectedSection.createdBy}</Typography>
              <Divider />
            </Box>

            <Box sx={{ mb: 2 }}>
              <Typography variant="subtitle2" color="text.secondary">Fecha de Actualización</Typography>
              <Typography variant="body1" sx={{ mb: 2 }}>{selectedSection.updatedAt}</Typography>
              <Divider />
            </Box>

            <Box sx={{ mb: 2 }}>
              <Typography variant="subtitle2" color="text.secondary">Actualizado Por</Typography>
              <Typography variant="body1">{selectedSection.updatedBy}</Typography>
            </Box>
          </Box>
        ) : (
          <Typography>No hay sección seleccionada</Typography>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} variant="outlined">Cerrar</Button>
      </DialogActions>
    </Dialog>
  );
};

export default ViewModal;
